import { useEffect } from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

// Create styles
const defaultStyles = StyleSheet.create({
    row: {
        display: "flex",
        flexDirection: "row",
        marginBottom: 10
    },
    rowHeader: {
        display: "flex",
        flexDirection: "row",
        fontSize: 10,
        borderBottom: "1px solid #777",
        paddingBottom: 5,
        marginBottom: 10
    },
    column: {
        flex: 1,
        padding: "0 10px"
    },
    textCenter: {
        textAlign: "center"
    },
    page: {
        padding: "30px 50px"
    },
    header: {
        fontSize: 16,
        overflowWrap: "break-word",
        marginBottom: 10
    },
    subheader: {
        fontSize: 12,
        marginBottom: 35
    },
    headerContainer: {
        padding: "0 15%",
        textAlign: "center",
        fontWeight: 60
    },
    table: {
        fontSize: 9
    }
});


const TableRow = props => {
    const { items, cols, styles } = props;
    return <>
        <View fixed style={styles.rowHeader}>
            {
                cols.map(c => <Text style={
                    {
                        ...styles.column,
                        textAlign: c.label === "Author/s" || c.label === "Title" ? "center" : "left",
                        flex: c.label === "Title" ? "0 0 50%" : 1
                    }}>
                    {c.label}
                </Text>)
            }
        </View>
        {
            items.map((item, i) => <View style={styles.row} key={i}>
                {
                    cols.map(c => <Text style={
                        {
                            ...styles.column,
                            textAlign: c.label === "Author/s" ? "center" : "left",
                            flex: c.label === "Title" ? "0 0 50%" : 1
                        }}>{c.value(item)}</Text>)
                }
            </View>)
        }
    </>
};
// Create Document Component
const MyDocument = props => {
    const styles = props.styles ?? defaultStyles;
    const { header, subheader, columns, data } = props;

    return <Document>
        <Page size={[612.0,936.0]} style={styles.page} orientation="landscape">
            <View style={styles.headerContainer}>
                <Text wrap style={styles.header}>{header}</Text>
                <Text style={styles.subheader}>{subheader}</Text>
            </View>
            <View style={styles.table}>
                <TableRow items={data} cols={columns} styles={styles} />
            </View>
        </Page>
    </Document>;
}

export default MyDocument;

{/*<Html>{ReactDOMServer.renderToStaticMarkup(props.content)}</Html>*/ }